const Leg = ({ x, y, alt, color, len = 16 }) => (
  <g transform={`translate(${x} ${y})`} className={`intro-leg ${alt ? "intro-leg-alt" : ""}`}>
    <path d={`M0 0 L2 ${len} L6 ${len + 2}`} stroke={color} strokeWidth="3.4" strokeLinecap="round" fill="none" />
  </g>
);

export const Cheetah = ({ x = 0, y = 0, scale = 1, legs = true }) => {
  const c = "#C9A24A";
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`}>
      <path d="M12 27 C0 24 -6 30 -14 36" stroke={c} strokeWidth="3" fill="none" strokeLinecap="round" />
      {legs && (
        <>
          <Leg x={24} y={28} color={c} />
          <Leg x={32} y={28} color={c} alt />
          <Leg x={82} y={26} color={c} alt />
          <Leg x={90} y={26} color={c} />
        </>
      )}
      <path
        d="M10 26 C14 14 34 10 56 12 C72 13 88 8 100 5 L108 9 L106 15 L96 18 L92 26 C86 30 70 30 60 29 L22 30 C14 32 8 31 10 26 Z"
        fill={c}
      />
      {[[20, 20], [30, 16], [42, 14], [54, 15], [66, 16], [76, 14], [36, 24], [50, 24], [64, 25], [26, 26]].map(([sx, sy], i) => (
        <circle key={i} cx={sx} cy={sy} r="1.6" fill="#2A1A0A" />
      ))}
      <path d="M97 10 L104 14" stroke="#1a1a1a" strokeWidth="1.2" />
      <circle cx="101" cy="9.5" r="1.2" fill="#0A0A0A" />
    </g>
  );
};

export const Deer = ({ x = 0, y = 0, scale = 1 }) => {
  const c = "#9C6A3A";
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`}>
      <path d="M60 7 L56 -6 M58 0 L52 -4 M60 7 L66 -5 M63 1 L69 -2" stroke="#E0CBA8" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <Leg x={16} y={30} color={c} len={18} />
      <Leg x={24} y={30} color={c} len={18} alt />
      <Leg x={46} y={29} color={c} len={18} alt />
      <Leg x={54} y={29} color={c} len={18} />
      <path
        d="M8 28 C10 18 26 14 44 16 C52 17 56 12 60 6 L66 8 L64 13 L68 17 L60 20 L56 28 C48 33 30 34 22 31 C14 32 8 32 8 28 Z"
        fill={c}
      />
      <circle cx="62" cy="9" r="1.1" fill="#0A0A0A" />
      <path d="M8 27 L4 22" stroke="#E0CBA8" strokeWidth="2" strokeLinecap="round" />
    </g>
  );
};

export const CarSide = ({ x = 0, y = 0, scale = 1, color = "#6B1F2A", flip = false }) => (
  <g transform={`translate(${x} ${y}) scale(${flip ? -scale : scale} ${scale})`}>
    <path d="M0 22 L8 12 L28 4 L58 3 L74 11 L92 15 L94 22 Z" fill={color} />
    <path d="M30 6 L56 5 L68 11 L34 12 Z" fill="#0A0A0A" />
    <rect x="86" y="15" width="7" height="3" fill="#F5E6A8" opacity="0.9" />
    <rect x="1" y="16" width="5" height="3" fill="#FF3B4A" opacity="0.9" />
    <circle cx="22" cy="23" r="6" fill="#050505" stroke="#B8B8B8" strokeWidth="1.5" />
    <circle cx="76" cy="23" r="6" fill="#050505" stroke="#B8B8B8" strokeWidth="1.5" />
  </g>
);

export const CarRear = ({ x = 0, y = 0, scale = 1, color = "#6B1F2A" }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <rect x="15" y="0" width="40" height="12" rx="3" fill="#111" stroke={color} strokeWidth="1.5" />
    <rect x="0" y="10" width="70" height="24" rx="4" fill={color} />
    <rect x="6" y="16" width="14" height="4" fill="#FF3B4A" />
    <rect x="50" y="16" width="14" height="4" fill="#FF3B4A" />
    <rect x="6" y="16" width="14" height="4" fill="#FF3B4A" opacity="0.6" filter="url(#intro-glow)" />
    <rect x="50" y="16" width="14" height="4" fill="#FF3B4A" opacity="0.6" filter="url(#intro-glow)" />
    <rect x="24" y="24" width="22" height="3" fill="#F5F5F5" opacity="0.8" />
    <rect x="-4" y="26" width="8" height="10" fill="#050505" />
    <rect x="66" y="26" width="8" height="10" fill="#050505" />
  </g>
);

export const CarTop = ({ x = 0, y = 0, scale = 1, color = "#6B1F2A" }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <rect x="4" y="-3" width="10" height="4" fill="#050505" />
    <rect x="44" y="-3" width="10" height="4" fill="#050505" />
    <rect x="4" y="21" width="10" height="4" fill="#050505" />
    <rect x="44" y="21" width="10" height="4" fill="#050505" />
    <rect x="0" y="0" width="60" height="22" rx="6" fill={color} />
    <rect x="34" y="3" width="10" height="16" rx="2" fill="#0A0A0A" />
    <rect x="18" y="3" width="6" height="16" rx="1" fill="#0A0A0A" opacity="0.7" />
    <rect x="57" y="4" width="3" height="4" fill="#F5E6A8" />
    <rect x="57" y="14" width="3" height="4" fill="#F5E6A8" />
  </g>
);


export const Ferrari812 = ({ x = 0, y = 0, scale = 1 }) => {
  const red = "#C4161C";
  const dark = "#7E0A10";
  return (
    <g transform={`translate(${x} ${y}) scale(${scale})`}>
      <ellipse cx="72" cy="41" rx="72" ry="4" fill="#000" opacity="0.4" />
      {/* body: low nose (left) rising to cabin, long tail (right) */}
      <path d="M4 30 L20 21 L60 16 L80 9 L112 9 L132 16 L140 24 L140 32 L4 32 Z" fill={red} />
      <path d="M4 30 L20 21 L60 16 L58 24 L10 29 Z" fill={dark} opacity="0.55" />
      {/* cabin glass */}
      <path d="M82 12 L110 11 L128 17 L84 19 Z" fill="#0B0B0B" opacity="0.9" />
      {/* side vent */}
      <path d="M52 20 L74 16 L72 26 L54 27 Z" fill={dark} opacity="0.7" />
      {/* headlight at nose (left) */}
      <path d="M5 25 L14 23 L14 27 L5 28 Z" fill="#F7E9A8" />
      {/* taillight at rear (right) */}
      <rect x="133" y="19" width="6" height="3.5" fill="#FF3B4A" />
      <rect x="30" y="31" width="86" height="2.5" fill="#0A0A0A" opacity="0.7" />
      <circle cx="36" cy="32" r="8.5" fill="#050505" stroke="#CFCFCF" strokeWidth="1.6" />
      <circle cx="116" cy="32" r="8.5" fill="#050505" stroke="#CFCFCF" strokeWidth="1.6" />
      <circle cx="36" cy="32" r="3.2" fill="#8A8A8A" />
      <circle cx="116" cy="32" r="3.2" fill="#8A8A8A" />
    </g>
  );
};
